export const RESPONSE_OK = 'OK';
export const RESPONSE_ERROR = 'ERROR';

export class ErrorResponse {
  status: string;
  error: string | {};
}

export class MetaResponse {
  status: string;
  message: string;
  meta: string;
}

export enum ContentType {
  TextPlain = 'text/plain',
  TextXml = 'text/xml',
  ApplicationPdf = 'application/pdf',
}
